// Services.
import { WaHelperService } from "../../wa-services/wa-helper-service";

// Classes.
import { EventBaseItem } from "./event-base.item";

export class ExtendedEventBaseItem extends EventBaseItem {
  public levelId: number;
  public levelLabel: string;
  public disciplineId: number;
  public dateFrom: string;
  public dateTo: string;
  public dateFromObj: Date;
  public dateToObj: Date;
  public place: string;
  public withRes: boolean;
  protected _dateString: string;
  isWorldRanking: boolean;
  isWorldRecordEvent: boolean;
  isCancelled: boolean;

  constructor(
    rawEventGeneralInfoItem: any,
    protected waHelperService: WaHelperService
  ) {
    super(rawEventGeneralInfoItem, waHelperService);
    this.place = rawEventGeneralInfoItem.Place;
    this.levelId = rawEventGeneralInfoItem.ComLevel;
    this.disciplineId = rawEventGeneralInfoItem.ComDis;
    this.dateFrom = rawEventGeneralInfoItem.DFrom;
    this.dateTo = rawEventGeneralInfoItem.DTo;
    this.dateFromObj = new Date(this.dateFrom);
    this.dateToObj = new Date(this.dateTo);
    this.dateFromObj = new Date(
      this.dateFromObj.getTime() +
        Math.abs(this.dateFromObj.getTimezoneOffset() * 60000)
    );
    this.dateToObj = new Date(
      this.dateToObj.getTime() +
        Math.abs(this.dateToObj.getTimezoneOffset() * 60000)
    );
    this.withRes = rawEventGeneralInfoItem.WithRes;
    this.isWorldRanking = rawEventGeneralInfoItem.WorldRankingEvent;
    this.isWorldRecordEvent = rawEventGeneralInfoItem.WorldRecordStatus;
    this.isCancelled = rawEventGeneralInfoItem.IsCancelled;
    this.levelLabel = this.waHelperService.getLevelInfo(this.levelId).label;
  }

  // Calculates if the event starts and finish in the same month.
  public sameMonth(): boolean {
    return this.dateFromObj.getMonth() == this.dateToObj.getMonth();
  }

  public get dateString(): string {
    if (!this._dateString) {
      this._dateString = WaHelperService.formatDateRange(
        this.dateFromObj,
        this.dateToObj
      );
    }
    return this._dateString;
  }

  public static eventDateFromSortFn(
    a: ExtendedEventBaseItem,
    b: ExtendedEventBaseItem
  ) {
    // @TODO: Use dateToObj that's a Date object instead of the string date?
    var dateA = a.dateFrom;
    var dateB = b.dateFrom;
    return EventBaseItem.dateCompare(dateA, dateB);
  }

  public static eventDateToSortFn(
    a: ExtendedEventBaseItem,
    b: ExtendedEventBaseItem
  ) {
    // @TODO: Use dateToObj that's a Date object instead of the string date?
    var dateA = a.dateTo;
    var dateB = b.dateTo;
    return EventBaseItem.dateCompare(dateA, dateB);
  }
}
